// extracted by mini-css-extract-plugin
export default {"container":"YjP_bgTORBirYb8KalNF","grid":"r6HPk4UvCWXzjZH2GkyG","title":"_BsGrB1NZN1DHM20B_Ax"};